import {
  LOADED,
  ADDED,
  TOGGLED,
  DELETED,
  COMPLETEALL,
  COLORSELECTED,
  CLEARCOMPLETED,
  EDITBTN,
  UPDATE,
} from "./ActionType";

export const loaded = (todos) => {
  return {
    type: LOADED,
    payload: todos,
  };
};

export const added = (text) => {
  return {
    type: ADDED,
    payload: text,
  };
};
export const toggled = (todoId) => {
  return {
    type: TOGGLED,
    payload: todoId,
  };
};
export const deleted = (todoId) => {
  return {
    type: DELETED,
    payload: todoId,
  };
};

export const colorSelected = (color, todoId) => {
  return {
    type: COLORSELECTED,
    payload: {
      color,
      todoId,
    },
  };
};
export const completeAll = () => {
  return {
    type: COMPLETEALL,
  };
};
export const clearCompleted = () => {
  return {
    type: CLEARCOMPLETED,
  };
};

export const editbtn = (id) => {
  return {
    type: EDITBTN,
    payload: id,
  };
};

export const update = (id, text) => {
  return {
    type: UPDATE,
    payload: {
      id,
      text,
    },
  };
};
